const mediaQueries = {
  mediaMaxXs: { minWidth: 1224 },
};

export default mediaQueries;
